import { createFileRoute } from "@tanstack/react-router";
import WellbeingPage from "@/pages/WellbeingPage";

export const Route = createFileRoute("/_app/wellbeing")({
  component: WellbeingPage,
});
